module.exports = __webpack_public_path__ + "img/phone.f0c427c.jpg";